<template>
  <div>
    <section>
      <h1>Whitelabel Companies</h1>
      <div>
        <button class="is-primary" @click="convertAll">
          Start Conversion
        </button>
      </div>

      <div v-if="converting">
        <p>Company {{ companiesConverted }}/{{ companies.length }} Converted</p>
      </div>
    </section>
  </div>
</template>

<script>
import page from '@/mixins/page'
import pagination from '@/mixins/pagination'

import {readCompaniesData, updateCompanyData} from '@/lib/companies'

export default {
  name: 'admin-whitelabel-companies',

  mixins: [page, pagination],

  data() {
    return {
      converting: false,
      companiesConverted: 0,
      success: false,
      steppingThrough: false,
      companies: [],
      sitesConverted: [],
      company: {},
      site: {},
      selectedSite: {},
      siteId: '',
      sites: [],
      page: {},
      list: {},
      lists: [],
      listTypes: [],
      errors: {},
      siteGalleries: [],
      galleryId: '',
      basicGalleryId: ''
    }
  },

  computed: {
    simpleFormId() {
      return this.listTypes.find((type) => type.name === 'simple-form').id
    }
  },

  methods: {
    getData() {
      readCompaniesData({page: 1, page_size: 250}).then(({data, page}) => {
        this.companies = data
        this.pageData = page
      })
    },

    convertAll() {
      this.converting = true

      this.companies.forEach((company, index) => {
        window.setTimeout(() => {
          this.whitelabelCompany(company.id)
        }, 1000 * index)
      })
    },

    whitelabelCompany(companyId) {
      let data = {white_label: true}

      updateCompanyData(companyId, data).then(() => {
        this.companiesConverted++
      })
    }
  },

  mounted() {
    this.getData()
  }
}
</script>

<style lang="sass"></style>
